import { Component, Input, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';

import { AbstractDialogComponent } from '../../../../../../Core/Dialogs/components/AbstractDialog/abstract-dialog.component';
import { CoreDialogService } from '../../../../../../Core/Dialogs/services/dialog.service';

import { ButtonTypesEnum } from '../../../../../../Common/Forms/enums/button-types.enum';
import { LocalizationService } from '../../../../../../Core/Localization/services/localization.service';
import { bannerErrorsMap } from '../../../../../Alerts/enums/alert-banner-error-type.enum';
import { BriefingBannerErrorTypeEnum } from '../../../../enums/briefing-banner-error-type.enum';
import { BriefingModel } from '../../../../models/briefing.model';
import { validateEmails } from '../../../../../../Common/Misc/helpers/formatting/email.helper';
import { MailingListsService } from '../../../../../../Common/MailingLists/services/mailing-lists.service';
import { EmailRecipientModel } from '../../../../../../Common/TargetingShared/model/statisticsReport/email-recipient.model';
import { ResizeDirectionEnum } from '../../../../../../Common/Forms/components/TextareaInput/textarea-input.component';
import { BriefingsService } from '@Monitor/Briefings/services/briefings.service';
import { mergeMap, pipe, switchMap } from 'rxjs';


@Component({
    selector: 'agpr-share-canvas-dialog',
    templateUrl: './share-canvas-dialog.component.html',
    styleUrls: ['./share-canvas-dialog.component.scss'],
    standalone: false
})
export class ShareCanvasDialogComponent extends AbstractDialogComponent implements OnInit {
    readonly id = 'shareCanvasDialog';
    readonly buttonType = ButtonTypesEnum;
    readonly maxInputTextLength: number = 256;
    readonly maxTextareaLength: number = 2048;
    readonly textareaRowNumber: number = 4;
    readonly resizeDirectionEnum = ResizeDirectionEnum;

    @Input() set briefing(value: BriefingModel) {
        this._briefing = value;
        this.fromName = value.fromName;
        this.replyTo = value.replyTo;
        this.inviteMessage = value.inviteMessage;
    }
    @Input() recipients: EmailRecipientModel[] = [];

    shareLoading: boolean = false;

    _briefing: BriefingModel;

    mailingListIds: number[] = [];
    mailingListInitializationTimes: number = 2;
    recipientList: string[] = [];
    excludeSubscribedRecipients: boolean = true;
    fromName: string;
    replyTo: string;
    inviteMessage: string;

    mailingListError: boolean = false;
    mailingListCountError: boolean = false;
    recipientListError: boolean = false;
    excludeSubscribedRecipientsError: boolean = false;
    fromNameError: boolean = false;
    replyToError: boolean = false;
    replyToInvalid: boolean = false;

    constructor(
        public coreDialogService: CoreDialogService,
        private messageService: MessageService,
        private localizationService: LocalizationService,
        public briefingsService: BriefingsService,
        public mailingListsService: MailingListsService,
    ) {
        super(coreDialogService, 'ShareCanvasDialog');
    }

    ngOnInit(): void {
    }

    mailingListChanged() {
        // This is a bit tricky, the handler will be triggered 2 times for initialization
        if (this.mailingListInitializationTimes > 0) {
            --this.mailingListInitializationTimes;
            return;
        }
        this.mailingListCountError = this.mailingListIds?.length && this.mailingListsService.getRecipientCount(this.mailingListIds) === 0;
        this.updateRecipientListError();
    }

    recipientListChanged() {
        this.updateRecipientListError();
    }

    excludeSubscribedRecipientsChanged() {
        // TODO: This part will be finished in NEP-33012
    }

    private updateRecipientListError() {
        // TODO: should we exclude the subscribed recipients?
        this.recipientListError = (!this.mailingListIds?.length || this.mailingListCountError) && !this.recipientList.length;
    }

    fromNameChanged() {
        this.fromNameError = !this.fromName || this.fromName.trim() === '';
    }

    replyToChanged() {
        this.replyToInvalid = !validateEmails(this.replyTo);
        this.replyToError = !this.replyTo || this.replyTo.trim() === '';
    }

    shareCanvas() {
        this.updateRecipientListError();
        this.fromNameChanged();
        this.replyToChanged();
        const hasErrors = this.recipientListError || this.fromNameError || this.replyToError;
        if (hasErrors) {
            return;
        }
        this._briefing.mailingListIds = this.mailingListIds;
        this._briefing.recipientList = this.recipientList;
        this._briefing.fromName = this.fromName;
        this._briefing.replyTo = this.replyTo;
        this._briefing.inviteMessage = this.inviteMessage;
        this.briefingsService.setCurrentBriefing(this._briefing);
        this.briefingsService.saveCurrentBriefing().pipe(
            switchMap(() => this.briefingsService.publishDraft(this.briefing.id))
        ).subscribe();
    }

    cancel(): void {
        this.closeDialog();
    }
}
